/**
 * Load/persist Pending Events
 * @module
 */
var _ = require('optimizely-client-fn');
var ApiEvents = require('../api_events');
var enums = require('core/constants/enums');
var JSONEnv = require('../lib/json');
var LocalStorage = require('../env/local_storage').LocalStorage;
var Logger = require('../utils/logger');
var xhr = require('core/utils/xhr');

var di = require('../di');
var PendingEventsStore = di.get('stores/pending_events');

var STORAGE_KEY = enums.StorageKeys.PENDING_EVENTS;

/**
 * Persist PendingEventsStore state to localStorage
 */
exports.persistPendingEvents = function() {
  try {
    var pendingEvents = PendingEventsStore.getEventsString();
    LocalStorage.setItem(STORAGE_KEY, pendingEvents);
    if (__XDOMAIN__) {
      // TODO(tyler): better way to declare this dependency
      require('../utils/xdomain_storage').setItem(STORAGE_KEY, pendingEvents);
    }
  } catch(e) {
    Logger.warn('PendingEvents / Unable to set localStorage key, error was: ', e);
    ApiEvents.emitInternalError(e);
  }
};

/**
 * Get unreceived pending events from local storage.
 * @returns {Object|null}
 */
exports.getPendingEvents = function(): any|null {
  try {
    return JSONEnv.parse(LocalStorage.getItem(STORAGE_KEY));
  } catch(e) {
    return null;
  }
};

/**
 * Retry pending log events
 * @param {Object} pendingEvents
 */
exports.retryPendingEvents = function(pendingEvents:any) {
  _.forOwn(pendingEvents, function(value, key) {
    xhr.retryableRequest(value.data, key, value.retryCount);
  });
  if (!_.isEmpty(pendingEvents)) {
    Logger.log('Retried pending events: ', pendingEvents);
  }
};
